import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Component({
  selector: 'app-logout-all',
  templateUrl: './logout-all.component.html',
  styleUrls: ['./logout-all.component.scss']
})
export class LogoutAllComponent implements OnInit {

  constructor(private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.auth.logoutAndClearAll();
  }
}
